import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../assets/murron-logo-wordmark.png';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { language } = useLanguage();

  const content = {
    zh: {
      tagline: '昭世家族办公室',
      description: '超越契约，世代相托。 Beyond Contracts, Trusted for Generations.',
      quickLinks: '快速链接',
      about: '关于我们',
      services: '服务',
      methodology: '方法论',
      insights: '洞见',
      contact: '联系方式',
      email: '邮箱',
      wechat: '微信',
      office: '香港办公室',
      followUs: '关注我们',
      wechatQR: '微信二维码',
      copyright: '版权所有',
      privacy: '隐私政策',
      terms: '服务条款',
      disclaimer: '本网站内容仅供一般参考，不构成任何法律、税务或投资意见。'
    },
    en: {
      tagline: 'FAMILY OFFICE',
      description: 'Beyond Contracts, Trusted for Generations.',
      quickLinks: 'Quick Links',
      about: 'About',
      services: 'Services',
      methodology: 'Methodology',
      insights: 'Insights',
      contact: 'Contact',
      email: 'Email',
      wechat: 'WeChat',
      office: 'Hong Kong Office',
      followUs: 'Follow Us',
      wechatQR: 'WeChat QR Code',
      copyright: 'All rights reserved',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      disclaimer: 'Content on this website is for general information only and does not constitute legal, tax or investment advice.'
    }
  };

  const t = content[language];

  return (
    <footer className="footer">
      <div className="footer-glow"></div>
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <img src={logo} alt="MuRRÓN Logo" className="footer-logo-image" />
            <h3 className="footer-logo">MuRRÓN</h3>
            <p className="footer-tagline en-title">{t.tagline}</p>
            <p className="footer-desc">
              {t.description}
            </p>
          </div>
          
          <div className="footer-section">
            <h4>{t.quickLinks}</h4>
            <ul>
              <li><Link to="/about">{t.about}</Link></li>
              <li><Link to="/services">{t.services}</Link></li>
              <li><Link to="/methodology">{t.methodology}</Link></li>
              <li><Link to="/insights">{t.insights}</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>{t.contact}</h4>
            <ul>
              <li>{t.email}: white@murronfamilyoffice.com</li>
              <li>{t.office}</li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} MuRRÓN FAMILY OFFICE. {t.copyright}.</p>
          <p className="footer-disclaimer">{t.disclaimer}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
